// Ported from [Nuxt](https://github.com/nuxt/nuxt/blob/main/packages/nuxt/src/app/composables/cookie.ts)
import { parse, serialize } from 'cookie-es'
import { destr } from 'destr'

const CookieDefaults = {
  path: '/',
  watch: true,
  decode: val => destr(decodeURIComponent(val)),
  encode: val => encodeURIComponent(typeof val === 'string' ? val : JSON.stringify(val)),
}

export const useCookie = (name, _opts) => {
  const opts = { ...CookieDefaults, ..._opts || {} }
  const cookies = parse(document.cookie, opts)
  let defaul = cookies[name] ?? opts.default?.()
  if(name === 'userAbilityRules') {
    if(defaul && defaul[0] && defaul[0].action) {
      defaul = null
    } else {

      defaul = defaul?.map(v => {return {subject: v[0], action: v[1]}})
    }
  }
  const cookie = ref(defaul)

  watch(cookie, () => {
    console.log('I set cookie for ', name)
    document.cookie = serializeCookie(name, cookie.value, opts)
  })
  
  return cookie
}
function serializeCookie(name, value, opts = {}) {
  if (value === null || value === undefined)
    return serialize(name, value, { ...opts, maxAge: -1 })
  if(name === 'userAbilityRules') {
    const ablities = value.map(v => {return [v.subject,v.action]})
    console.log('im compress cookie', name, ablities)
    return serialize(name, ablities, opts)
  }
  return serialize(name, value, opts)
}
